export const menu = {
  title: "Meny",
  description: "Alla sidor, ditt konto och juridik.",
  signInUp: "Logga in eller skapa konto",
  explore: "Utforska",
  myPages: "Mina sidor",
  myOverview: "Min översikt",
  myAds: "Mina annonser",
  myItems: "Mina prylar",
  new: "Nytt",
  myDeals: "Mina köp och sälj",
  myBids: "Mina bud",
  saved: "Sparade annonser",
  watchlist: "Bevakningar",
  stats: "Statistik",
  account: "Konto",
  myProfile: "Min profil",
  myAddresses: "Mina adresser",
  myAccount: "Mitt konto",
  myCases: "Mina ärenden",
  about: "Om Sellavo",
  languageCountry: "Språk och land",
  appearance: "Utseende",
  themeAuto: "Följ solen",
  themeLight: "Ljust",
  themeDark: "Mörkt",
  legal: "Juridik & cookies",
  admin: "Admin",
  administration: "Administration",
  signOut: "Logga ut",
};
